// @flow
import * as React from 'react';
import * as Immutable from 'immutable';
import { Divider, Stack } from '@locus-taxy/neo-ui';
import { ListWithHeader } from 'common/components/core/list/ListWithHeader';
import { tableButtonWithPopoverFactory } from 'common/components/common/TableButtonWithPopover';
import { VehicleCompartment } from 'common/models/internal/VehicleCompartment';
import type UnitConversionHelper from 'common/helpers/UnitConversionHelper';
import Compartment from './Compartment';
import type { TFunction } from 'react-i18next';
import type { ThemeType } from 'react-css-themr';

type Props = {
    list: Immutable.List<VehicleCompartment>,
    title: string,
    t: TFunction,
    unitConverter: UnitConversionHelper,
    theme: ThemeType
};

const VehicleCompartmentsList = ({
    theme,
    t,
    list: compartments,
    title,
    unitConverter
}: Props): React.Node => {
    return (
        <ListWithHeader className={theme.partsList} theme={theme} title={title}>
            <Stack space="small">
                {compartments.map((compartment, index) => {
                    return (
                        <React.Fragment key={index}>
                            <Compartment
                                compartment={compartment}
                                title={`${t(
                                    'masterVehicleModelProperties.compartments.compartment'
                                )} ${index + 1}`}
                                t={t}
                                unitConverter={unitConverter}
                            />

                            {index !== compartments.size - 1 ? (
                                <Divider color="grey.100" width="fluid" />
                            ) : null}
                        </React.Fragment>
                    );
                })}
            </Stack>
        </ListWithHeader>
    );
};

export const VehicleCompartmentsDetails = tableButtonWithPopoverFactory({
    ListElement: VehicleCompartmentsList
});

export default VehicleCompartmentsDetails;
